import { Benefit, CostSharing, MetalLevelEnum, Plan as CMSPlan, PlanTypeEnum } from './cms_types';
import { TestPlans } from './objects_test';
interface _PlanPrices {
	/** Doctor */
	doctor_primary_visit: number;
	doctor_specialist_visit: number;
	doctor_preventative_visit: number;

	/** Drugs */
	drugs_generic: number;
	drugs_brand: number;
	drugs_non_brand: number;
	drugs_specialty: number;

	/** Dental */
	dental_routine_adult: number;
	dental_routine_child: number;
	dental_major_adult: number;
	dental_major_child: number;
	dental_basic_adult: number;
	dental_basic_child: number;

	/** Labs */
	labs_xrays: number;
	labs_imaging: number;
	labs_blood_work: number;

	/** Hospital */
	hospital_urgent_care: number;
	hospital_emergency_room: number;
	hospital_ambulance: number;
	hospital_stay_facility: number;
	hospital_stay_physician: number;
	hospital_outpaintent_facility: number;
	hospital_outpaintent_physician: number;
	hospital_rehabilitation: number;

	/** Mental */
	mental_outpatient: number;
	mental_psychiatric: number;

	/** Pregnancy */
	pregnancy_baby_care: number;
	pregnancy_labor: number;
}
export type PlanPrices = Partial<_PlanPrices>;

export interface Plan {
	id: string;
	name: string;
	icon?: string;
	badges?: string[];

	premium: number;
	premium_promo_full?: number;
	all_in?: number;

	/** per person */
	deductible: number;
	pocket_max: number;

	network_type?: PlanTypeEnum;
	metal_tier?: MetalLevelEnum;

	benefits?: (Benefit & { network_in?: CostSharing; network_out?: CostSharing })[];

	/** 0 means free, -1 means full */
	prices_bd?: PlanPrices;
	prices_ad?: PlanPrices;
	prices_ad_no?: PlanPrices;

	preventative_care?: { name: string; description?: string; learn_more?: string }[];
	urls?: { [key: string]: string };
}

export const PlanFromCMSPlan = (v: CMSPlan) => {
	// const prices_ad = v.benefits.reduce<PlanPrices>((a, v) => {
	//     let in_network = v.cost_sharings.find(v => v.network_tier === 'In-Network')
	//     switch(v.name){
	//         case 'Generic Drugs': a.drugs_generic=in_network?.coinsurance_rate?in_network.coinsurance_rate:-2; break;
	//         case 'Major Dental Care - Adult': a.=in_network?.coinsurance_rate?in_network.coinsurance_rate:-2; break;
	//     }
	//     return a;
	// }, {} as PlanPrices)

	const { prices_ad, prices_ad_no } = v.benefits.reduce(
		(pp, b) => {
			// Why aren't benefits and coinsurances in HS matching up?
			const nameMap: { [key: string]: string } = {
				'Generic Drugs': 'drugs_generic',
				'Primary Care Visit to Treat an Injury or Illness': 'doctor_primary_visit', // maybe ??

				// Dental care?
				'Routine Dental Services (Adult)': 'dental_routine_adult', // preventative
				'Dental Check-Up for Children': 'dental_routine_child', // preventative
				'Major Dental Care - Adult': 'dental_major_adult',
				'Major Dental Care - Child': 'dental_major_child',
				'Basic Dental Care - Adult': 'dental_basic_adult',
				'Basic Dental Care - Child': 'dental_basic_child',

				'Specialist Visit': 'doctor_specialist_visit',
				'Emergency Room Services': 'hospital_emergency_room',
			};
			const name = nameMap[b.name];
			if (name) {
				b.cost_sharings.forEach((cs) => {
					switch (cs.network_tier) {
						case 'In-Network':
							pp.prices_ad[name] = cs.coinsurance_rate;
							break;
						case 'Out-of-Network':
							pp.prices_ad_no[name] = cs.coinsurance_rate;
							break;
						case 'Combined In-Out of Network':
							pp.prices_ad[name] = cs.coinsurance_rate;
							pp.prices_ad_no[name] = cs.coinsurance_rate;
							break;
					}
				});
			}
			return pp;
		},
		{
			prices_ad: {} as PlanPrices,
			prices_ad_no: {} as PlanPrices,
		}
	);
	const d = TestPlans[0];
	const plan: Plan = {
		// ...d,
		id: v.id,
		name: v.name,
		premium: v.premium,
		deductible: v.deductibles?.length ? v.deductibles.reduce((a, v) => (v.amount > a ? v.amount : a), 0) : d.deductible,
		pocket_max: v.moops?.length ? v.moops.reduce((a, v) => (v.amount > a ? v.amount : a), 0) : d.pocket_max,
		metal_tier: v.metal_level,
		network_type: v.type,
		// Extracting all urls from plan
		urls: Object.entries(v)
			.filter(([k, v]) => k.includes('url'))
			.reduce((a, [k, v]) => {
				a[k.substr(0, k.indexOf('_url'))] = v;
				return a;
			}, {}),
		benefits: v.benefits.map((b) => {
			return {
				...b,
				network_in: b.cost_sharings.find((c) => c.network_tier === 'In-Network'),
				network_out: b.cost_sharings.find((c) => c.network_tier === 'Out-of-Network'),
			};
		}),
		prices_ad,
		prices_ad_no,
	};
	return plan;
};
